module.exports = __webpack_public_path__ + "media/images/lavita_banner/banner__between--de-c376c17baf0b8369e4daacd161bbe8ab.jpg";